/* LogoMontanas — SVG inline del logo institucional DMU 614 (Chihuahua).
   3 montañas estilizadas en dorado sobre fondo azul marino.
   Solicitado por Octavio (11-jun-2026) para reemplazar la gota antigua. */
export default function LogoMontanas({ size = 56, className = "", ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="DMU 614"
      role="img"
      {...rest}
    >
      <rect x="0" y="0" width="56" height="56" rx="10" fill="#1a2e5a"/>
      <polyline points="8,40 19,8 31,40" fill="none" stroke="#C9A84C" strokeWidth="1.5" strokeLinejoin="round" opacity="0.6"/>
      <polyline points="14,40 29,3 44,40" fill="none" stroke="#C9A84C" strokeWidth="2.5" strokeLinejoin="round"/>
      <polyline points="21,40 33,14 45,40" fill="none" stroke="#C9A84C" strokeWidth="1.2" strokeLinejoin="round" opacity="0.6"/>
      <circle cx="29" cy="0" r="3" fill="#C9A84C"/>
    </svg>
  );
}
